// Auth.js - Some wrappers for handling with authentication stuff
import store from '../store/index';
import { eventBus } from '../main';

function checkIdentification() {
    return !!store.getters[store.types.loggedinAccount.getters.get].identification;
}

function checkNonTempToken() {
    return checkToken(false);
}

function checkTempToken() {
    return checkToken(true);
}

function getTokenTime() {
    return getToken(true).expireTime || getToken(false).expireTime;
}

function logoutAccount() { // Logs you out of an account
    return store.dispatch(store.types.loggedinAccount.actions.reset);
}

function logoutUser() { // Logs the user out from the system
    const logoutFromAccount = logoutAccount();
    const removeUserData = store.dispatch(store.types.user.actions.reset);
    const removeTokenData = store.dispatch(store.types.token.actions.reset);
    const logoutFromChat = new Promise(resolve => {
        window.parleySettings.deleteAllDataFromStorage();
        window.parleySettings.hideParleyMessenger();
        window.parleySettings.authHeader = ''; // Throw away the authHeader
        resolve();
    });
    const logoutEvent = new Promise(resolve => {
        eventBus.$emit('userLoggedout');
        resolve();
    });

    return Promise.all([logoutFromAccount, removeUserData, removeTokenData, logoutFromChat, logoutEvent]);
}

function getRightsList() {
    return rights;
}

function getRightsById(ids) {
    let returnList = [];
    ids.forEach(id => {
        id = parseInt(id.toString()); // Make sure the id is an integer
        Object.keys(rights).forEach(key => {
            if (rights[key].id === id)
                returnList.push(rights[key]);
        });
    });

    return returnList;
}

function parleyChatLogin(authHeader) {
    store.dispatch(store.types.user.actions.set, {authHeader: authHeader});

    window.parleySettings.registerNewDevice(authHeader, () => {}, () => {});
}

/* Private functions */
function getToken(temp) {
    let tokenObject = store.getters[store.types.token.getters.get_nontemp];

    if (temp)
        tokenObject = store.getters[store.types.token.getters.get_temp];

    return tokenObject || false;
}

function checkToken(temp) {
    const tokenObject = getToken(temp);

    if (!tokenObject)
        return false;

    const token = tokenObject.token; // Token
    const expireToken = tokenObject.expireTime; // Token expire timestamp in seconds
    const timestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds

    return (token && expireToken && timestamp < expireToken);
}

/* Rights list */
const rights = { };
rights.GetSharedSecret = { id: 1, description: 'Retrieving the shared secret' };
rights.AuthorizationHeadersSettings = { id: 2, description: 'Changing Authorization Header settings' };
rights.AuthorizationHeaderGenerateAndValidate = { id: 3, description: 'Authorization Header generate and validate' };
rights.UpdateDesignSettings = { id: 4, description: 'Updating the design settings' };
rights.SearchUsersInAccount = { id: 5, description: 'Search users within the account' };
rights.ManageUsers = { id: 6, description: 'Manage the users by attaching, detaching or updating the rights for a users' };
rights.CreateUser = { id: 7, description: 'Create a user' }; // TODO: Not implemented
rights.GetStatistics = { id: 8, description: 'View all the statistics' };
rights.WebPushSettings = { id: 9, description: 'Change push settings for web library' };
rights.AndroidPushSettings = { id: 10, description: 'Change push settings for android library' };
rights.iOSPushSettings = { id: 11, description: 'Change push settings for ios library' };
rights.ManageOfficeHours = { id: 12, description: 'Change office hours config values' };
rights.ManageServices = { id: 13, description: 'Change service configurations' };
rights.ManageDataretention = { id: 14, description: 'Change data retention settings' };
rights.FCMV1PushSettings = { id: 15, description: 'Change push settings for every library that uses fcm v1' }; // TODO: Implement FCMv1 config page
Object.freeze(rights); // Disable changing of the object

export default {
    requireToken: checkNonTempToken,
    requireIdentification: checkIdentification,
    requireTempToken: checkTempToken,
    logoutAccount: logoutAccount,
    logoutUser: logoutUser,
    getRightsList: getRightsList,
    getRightsById: getRightsById,
    parleyChatLogin: parleyChatLogin,
    getTokenTime: getTokenTime
};
